<lib-preloader [loading]="loading" [text]="config.downloadText"></lib-preloader>
<lib-preloader [loading]="uploading" [text]="config.uploadingText"></lib-preloader>
<ng-container *ngIf="!uploading && !isEng">
    <div class="oops" *ngIf="!isStartConfirmed && !loading && !isActive">
        <div class="text-center">
            <h2 class="title">
                Щось пішло не так
            </h2>
            <img src="assets/icons/eye.gif" alt="eye">
        </div>
    </div>
    <div class="start-warning-wrapper" *ngIf="isStartConfirmed && !isActive">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h3>
                        Увага! Зображення, що можуть викликати тривожність! Розпочинайте тест на власний розсуд.
                    </h3>
                    <button type="button" class="btn btn-primary  mb-3 " (click)="onStart()">
                        Все одно почати
                    </button>
                </div>
                <div class="col-md-6 d-flex flex-column justify-content-center align-items-center">
                    <img src="assets/icons/esc.gif" alt="esc">
                    <br>
                    <p>Ви можете зупинити тест в будь-який момент<br>натиснувши Esc на клавіатурі</p>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!uploading">
    <div id="body" class="test-wrapper" [ngClass]="{'isActive': isActive, isReading: isReading}">
        <!--    *ngFor="let slide of steps; let i=index"-->
        <div #wrapper>
            <div class="slide-wrapper container-fluid mb-3 "
                 *ngIf="currentStepIndex > -1"
                 [ngClass]="{'lose-face': !detected}">
                <div class="slide empty-slide text-center"
                     [ngClass]="{'active':steps[currentStepIndex]?.type === 'empty'}">
                    <img class="plusIcon" *ngIf="steps[currentStepIndex]?.type === 'empty'"
                         (load)="onImgLoad($event, 'empty',0)"
                         [src]="'assets/icons/empty-focus.png'">
                    <app-circle-progress [progress]="currentStepIndex *100 / steps.length">
                    </app-circle-progress>

                </div>

                <div *ngIf="!isReading" class="slide imageSet"
                     [ngClass]="{'active':imageSetLoaded}">
                    <div class="wrapper" *ngIf="steps[currentStepIndex]?.type === 'imageSet'">
                        <div #lImgWrapper class="lImgWrapper">
                            <img class="img"
                                 (load)="onImgLoad($event, 'imageSet', 1)"
                                 [ngClass]="steps[currentStepIndex]?.data?.l_type" #lImg
                                 [src]="steps[currentStepIndex]?.data?.l_src.src" alt="">
                            <!--              <img class="portrait"-->
                            <!--                   src="https://api-fcqs5w5o5a-ew.a.run.app/api/storage/content/12479672">-->
                        </div>
                        <div #rImgWrapper class="rImgWrapper">
                            <img
                                    class="img"
                                    (load)="onImgLoad($event, 'imageSet', 2)"
                                    [ngClass]="steps[currentStepIndex]?.data?.r_type"
                                    #rImg [src]="steps[currentStepIndex]?.data?.r_src.src" alt="">
                        </div>
                    </div>
                    <div class="wrapper" *ngIf="steps[currentStepIndex]?.type === 'image'">
                        <div
                                class="articleImgWrapper"
                                *ngFor="let img of steps[currentStepIndex].images; let i = index">
                            <img class="img bumper"
                                 [id]="'x'+i"
                                 (load)="onImgLoad($event, 'image', i)"
                                 [src]="steps[currentStepIndex].images[i].src">
                        </div>
                    </div>
                </div>
                <div *ngIf="isReading" class="slide imageSet reading"
                     [ngClass]="{'active':imageSetLoaded}">

                    <div class="wrapper">
                        <div class="text" id="text">
                            <lib-reading-instructions [hideResultWarning]="!isReading"
                                                      [text]="config.readingInfo"></lib-reading-instructions>

                            <lib-dast-renderer
                                    *ngIf="steps[currentStepIndex]?.article?.document"
                                    [dastNode]="steps[currentStepIndex].article.document"></lib-dast-renderer>
                        </div>
                        <div class="answers">
                            <div
                                    class="articleImgWrapper"
                                    [attr.style]="'height: ' + getImageHeight(steps[currentStepIndex].images) + '%'"
                                    [ngClass]="{'active': isImageSelected(img.id) }"
                                    *ngFor="let img of steps[currentStepIndex].images; let i = index">
                                <img class="img"
                                     [id]="'x'+i"
                                     (load)="onImgLoad($event, 'article', i)"
                                     (click)="onImgSelected(img)"
                                     [src]="steps[currentStepIndex].images[i].src">
                            </div>
                            <div class="action-wrapper">
                                <button
                                        [disabled]="!selectedImg"
                                        (click)="onActionClick(selectedImg)"
                                        class="action-btn hover_action">
                                    Далі
                                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 13.1328L7 7.13281L1 1.13281" stroke="#fff" stroke-width="1.5"
                                              stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="uploading">

</ng-container>
<div class="dot" style="position: absolute; top: 50px; left: 150px">

</div>
